(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/mybets/ongoingbetslist.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/mybets/ongoingbetslist.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.OnGoingBetsList = Marionette.CollectionView.extend({
    tagName: 'ul',
    className:
      'list-group list-group-default color-grey-500 margin-1 ongoing-games',
    childView: svs.bingo.views.BetRow,

    collectionEvents: {
      remove: 'render'
    },

    initialize: function() {
      svs.bingo.nyxChannel.on('GameCompleted', this.onGameCompleted, this);
      this.listenTo(this.collection, 'remove', this.render);
    },

    onBeforeRender: function() {
      $('body').addClass('bg-grey-300');
    },

    onGameCompleted: function() {
      var activeModel,
        wagerId = Backbone.history.fragment.match('[0-9]+')[0];

      if (wagerId) {
        activeModel = this.collection.where({ wagerId: wagerId });
        this.collection.remove(activeModel);
      }
    },

    onDestroy: function() {
      $('body').removeClass('bg-grey-300');
      svs.bingo.nyxChannel.off('GameCompleted', this.onGameCompleted, this);
    }
  });
})(Backbone, _, svs);


 })(window);